import classNames from 'classnames'
import type {HTMLAttributes} from 'react'

import {DEFAULT_GRID_ID} from './Grid.consts'

import styles from './Grid.css'

type Props = HTMLAttributes<HTMLDivElement> & {
  span?: number
  gridId?: string
}
export default function RowGroup({
  span = 1,
  gridId = DEFAULT_GRID_ID,
  className,
  ...restProps
}: Props) {
  return (
    <div
      className={classNames(styles.rowGroup, className)}
      data-grid-row-span={span}
      data-grid-id={gridId}
      {...restProps}
    />
  )
}
